
import React from "react";
import PropTypes from "prop-types";

export default function CardAboutUs({
  id,
  image,
  size,
}) {
  const sizes = {
    sm: "h-330-px",
    md: "h-430-px",
    lg: "h-530-px",
  };
  return (
    <>

            <img id = {id}
              src={image}
              className= { "w-full rounded-lg rounded-r-none" + sizes[size] }
              alt="..."
            />
      
    </>
  );
}
CardAboutUs.defaultProps = {
  innerLink: false,
  rounded: true,
  size: "md",
};

CardAboutUs.propTypes = {
  id:PropTypes.string,
  image: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["sm", "lg", "md"]),
};
